exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sv-chat-controls {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.sv-chat-controls button.win-button {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  min-width: auto;\n}\n.sv-chat-controls button.win-button.highlighted {\n  color: #ff0;\n}\n.sv-chat-content {\n  color: #c0c0c0;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.sv-chat-content .chat-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sergeisidorov/Projects/streamViewer/src/app/components/chat.component/chat.component.styl
// module id = ../../../../../src/app/components/chat.component/chat.component.styl
// module chunks = main